import { stat } from '@qsk/slime-core';
import { gioTrackByList } from '../utils/gio';

export default class GioClick {
  static install(Vue) {
    Vue.directive('tj-click', {
      bind(el) {
        el.addEventListener('click', () => {
          const log = JSON.parse(el.dataset?.log || '{}');
          const logData = gioTrackByList('click', log);
          const { banClick } = logData;
          delete logData.banClick;
          if (!banClick && logData && logData.obj_id) {
            stat.track('click', logData);
          }
        });
      },
    });
  }
}
